// Lazy-import the Lottie player exactly once. esbuild's dynamic-import
// splitting puts the dotlottie-web library into its own chunk, so it
// only ships to clients that actually render a profile-effect with a
// .json image_url.

let loadPromise = null;

export function loadLottiePlayer() {
  if (!loadPromise) {
    loadPromise = import('@lottiefiles/dotlottie-web').catch((err) => {
      loadPromise = null; // allow retry on next call
      throw err;
    });
  }
  return loadPromise;
}
